import { render, staticRenderFns } from "./RecordViewSide.vue?vue&type=template&id=e2dcfa12&"
import script from "./RecordViewSide.vue?vue&type=script&lang=js&"
export * from "./RecordViewSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports